import React from 'react';

function Icon(props) {
  if (props.size === 'sm') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
        <path d="M384.23-281.69q-36.77 0-62.65-25.66-25.89-25.66-25.89-62.43 0-36.76 25.66-62.64 25.66-25.89 62.42-25.89 36.77 0 62.65 25.66 25.89 25.66 25.89 62.42 0 36.77-25.66 62.65-25.66 25.89-62.42 25.89M228.31-116q-27.01 0-45.66-19T164-180.31v-503.38Q164-710 182.65-729t45.66-19h87.38v-100.61h53.54V-748h223.08v-100.61h52V-748h87.38q27.01 0 45.66 19T796-683.69v503.38Q796-154 777.35-135t-45.66 19zm0-52h503.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-335.38H216v335.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85M216-567.69h528v-116q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H228.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46zm0 0V-696z"></path>
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <mask id="mask0_22_5192" style={{ maskType: 'alpha' }} width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse">
        <path fill="#D9D9D9" d="M0 0H24V24H0z"></path>
      </mask>
      <g mask="url(#mask0_22_5192)">
        <path
          fill={props.fill || '#1D252D'}
          d="M14.692 18.058a2.226 2.226 0 01-1.635-.672 2.226 2.226 0 01-.672-1.636c0-.642.224-1.187.672-1.636a2.226 2.226 0 011.635-.672c.643 0 1.188.224 1.636.672.448.449.672.994.672 1.636 0 .642-.224 1.188-.672 1.636a2.226 2.226 0 01-1.636.672zm-9.384 3.5c-.505 0-.933-.175-1.283-.525A1.745 1.745 0 013.5 19.75V6.365c0-.505.175-.932.525-1.282.35-.35.778-.525 1.283-.525h1.384V3.212c0-.22.074-.403.22-.55a.745.745 0 01.55-.22c.219 0 .402.074.549.22.146.147.22.33.22.55v1.346h7.577V3.192c0-.212.071-.39.215-.534a.726.726 0 01.535-.216c.212 0 .39.072.534.216a.726.726 0 01.216.534v1.366h1.384c.505 0 .933.175 1.283.525.35.35.525.777.525 1.282V19.75c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H5.308zm0-1.5h13.384a.3.3 0 00.221-.087.3.3 0 00.087-.221v-9.384H5v9.384a.3.3 0 00.087.221.3.3 0 00.22.087zM5 8.865h14v-2.5a.3.3 0 00-.087-.22.3.3 0 00-.22-.087H5.307a.3.3 0 00-.221.086.3.3 0 00-.087.221v2.5z"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
